import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import StandardButton from "../../../../components/StandardButton";
import { AutoAwesome as AIIcon, Restaurant as RecipeIcon } from "@mui/icons-material";
import EmptyStateCard from "../../../../components/EmptyStateCard";
import useEvents from "../../../../hooks/useEvents";

type EmptyRecipesProps = {
  onAddRecipe: () => void;
  onGenerateRecipe?: () => void;
  showAIGeneration?: boolean;
};

const EmptyRecipes = ({ onAddRecipe, onGenerateRecipe, showAIGeneration = false }: EmptyRecipesProps) => {
  const events = useEvents();
  
  return (
    <Box data-testid="EmptyRecipesView" style={{ margin: 24 }}>
      <EmptyStateCard
        text="Start building your recipe collection! Create nutritious recipes that you can include in meal plans for your clients."
      />
      <Box
        style={{
          marginTop: 24,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack style={{ maxWidth: 500, alignItems: "center" }} spacing={2}>
          <Typography style={{ textAlign: "center", marginBottom: 16 }}>
            Add recipes with ingredients, instructions, and nutritional information. 
            Your recipes will be available when creating meal plans for clients.
          </Typography>
          
          <Stack direction="row" spacing={2}>
            <StandardButton
              data-testid="EmptyRecipesView-AddButton"
              variant="primary"
              size="small"
              startIcon={<RecipeIcon />}
              onClick={() => {
                onAddRecipe();
                events.logButtonClick({
                  buttonName: "Add Your First Recipe",
                  pageName: "Nutrition",
                  tabName: "Recipes",
                });
              }}
            >
              Add Your First Recipe
            </StandardButton>
            
            {showAIGeneration && onGenerateRecipe && (
              <StandardButton
                data-testid="EmptyRecipesView-AIButton"
                variant="secondary"
                size="small"
                startIcon={<AIIcon />}
                onClick={() => {
                  onGenerateRecipe();
                  events.logButtonClick({
                    buttonName: "Generate Recipe with AI",
                    pageName: "Nutrition", 
                    tabName: "Recipes",
                  });
                }}
              >
                Generate with AI
              </StandardButton>
            )}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default EmptyRecipes;